<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div [hidden]="isCreate || isEdit">
      <div class="header-container">
        <h2>Location</h2>
        <div class="search-container">
          <input
            type="text"
            [formControl]="searchInput"
            placeholder="Search..."
            (input)="applyFilter()"
            class="form-control"
          />
          <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="add()">Add Location</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>

          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
            <td mat-cell *matCellDef="let element">{{element.location_name}}</td>
          </ng-container>

          <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
            <td mat-cell *matCellDef="let element">{{element?.district?.state?.country?.country_name}}</td>
          </ng-container>

          <ng-container matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
            <td mat-cell *matCellDef="let element">{{element?.district?.state?.zone?.zone_name}}</td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
            <td mat-cell *matCellDef="let element">{{element?.district?.state?.state_name}}</td>
          </ng-container>

          <ng-container matColumnDef="region">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
            <td mat-cell *matCellDef="let element">{{element?.district?.region?.region_name}}</td>
          </ng-container>


          <ng-container matColumnDef="district">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>District</th>
            <td mat-cell *matCellDef="let element">{{element?.district?.district_name}}</td>
          </ng-container>


          <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Area</th>
            <td mat-cell *matCellDef="let element">{{element?.area?.area_name}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="editData(element)">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="10">No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>Location</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="locationForm">
        <div class="row">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Location Name</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <input type="text" class="form-control" placeholder="Location Name" formControlName="location"
                  maxlength="60" [ngClass]="{ 'is-invalid': submitted && f['location'].errors }" />
                <div *ngIf="submitted && f['location'].errors" class="invalid-feedback">
                  <div *ngIf="f['location'].errors['required']">
                    Location Name is required
                  </div>
                </div>
              </div>
            </div>


            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Country</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="country" (change)="getZoneList()"
                  [ngClass]="{ 'is-invalid': submitted && f['country'].errors }">
                  <option value="" disabled selected>--Select Country--</option>
                  <option [value]="data.id" *ngFor="let data of countryList">{{data.country_name}}</option>
                </select>
                <div *ngIf="submitted && f['country'].errors" class="invalid-feedback">
                  <div *ngIf="f['country'].errors['required']">Country is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Zone</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="zone" (change)="getStateList()"
                  [ngClass]="{ 'is-invalid': submitted && f['zone'].errors }">
                  <option value="" disabled selected>--Select Zone--</option>
                  <option [value]="data.id" *ngFor="let data of zoneList">{{data.zone_name}}</option>
                </select>
                <div *ngIf="submitted && f['zone'].errors" class="invalid-feedback">
                  <div *ngIf="f['zone'].errors['required']">Zone is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>State</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="state" (change)="getRegionList()"
                  [ngClass]="{ 'is-invalid': submitted && f['state'].errors }">
                  <option value="" disabled selected>--Select State--</option>
                  <option [value]="data.id" *ngFor="let data of stateList">{{data.state_name}}</option>
                </select>
                <div *ngIf="submitted && f['state'].errors" class="invalid-feedback">
                  <div *ngIf="f['state'].errors['required']">State is required</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Region</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="region" (change)="getDistrictList()"
                  [ngClass]="{ 'is-invalid': submitted && f['region'].errors }">
                  <option value="" disabled selected>--Select Region--</option>
                  <option [value]="data.id" *ngFor="let data of regionList">{{data.region_name}}</option>
                </select>
                <div *ngIf="submitted && f['region'].errors" class="invalid-feedback">
                  <div *ngIf="f['region'].errors['required']">Region is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>District</label>
                <select name="" class="form-select" formControlName="district" (change)="getAreaList()"
                  [ngClass]="{ 'is-invalid': submitted && f['district'].errors }">
                  <option value="" disabled selected>--Select District--</option>
                  <option [value]="data.id" *ngFor="let data of districtList">{{data.district_name}}</option>
                </select>
                <div *ngIf="submitted && f['district'].errors" class="invalid-feedback">
                  <div *ngIf="f['district'].errors['required']">District is required</div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Area</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="area"
                  [ngClass]="{ 'is-invalid': submitted && f['area'].errors }">
                  <option value="" disabled selected>--Select Area--</option>
                  <option [value]="data.id" *ngFor="let data of areaList">{{data.area_name}}</option>
                </select>
                <div *ngIf="submitted && f['area'].errors" class="invalid-feedback">
                  <div *ngIf="f['area'].errors['required']">Area is required</div>
                </div>
              </div>
            </div>


            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-2">
              <div class="themeinput">
                <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
                <select name="" class="form-select" formControlName="status"
                  [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                  <option value="" disabled selected>--Select Status--</option>
                  <option value="1">Active</option>
                  <option value="0">In-Active</option>
                </select>
                <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
                  <div *ngIf="f['status'].errors['required']">Status is required</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button *ngIf="isCreate" mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
              <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button (click)="create()">Create</button>
              <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button (click)="update()">Update</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>